<script lang="ts">
import type { VariantProps } from 'tailwind-variants';
import type { IconProps } from '#ui/types';
import { tv } from 'tailwind-variants';

const iconFrameStyles = tv({
	base: 'inline-flex size-full items-center justify-center rounded-[10%] text-(--icon-color)',
	variants: {
		variant: {
			soft: 'bg-(--icon-color)/10',
			ghost: 'bg-transparent hover:bg-(--icon-color)/10',
			link: 'bg-transparent',
		},
		spacing: {
			none: 'p-0',
			tight: 'p-[12%]',
			comfortable: 'p-[24%]',
		},
	},
	defaultVariants: {
		variant: 'soft',
		spacing: 'tight',
	},
});

type IconFrameVariants = VariantProps<typeof iconFrameStyles>;

export interface IconFrameProps extends IconProps {
	color?: string;
	variant?: IconFrameVariants['variant'];
	spacing?: IconFrameVariants['spacing'];
	disabled?: boolean;
}
</script>

<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core';

const props = defineProps<IconFrameProps>();

const forwarded = reactiveOmit(props, 'color', 'variant', 'spacing');
</script>

<template>
	<span :style="{ '--icon-color': color }" class="inline-flex items-stretch justify-stretch">
		<span :class="iconFrameStyles({ variant, spacing })">
			<DIcon v-bind="forwarded" class="size-full aria-disabled:text-dimmed" :aria-disabled="disabled" />
		</span>
	</span>
</template>
